import { render } from "./CheckCircle.svg?vue&type=template&id=70b24b58"
const script = {}
script.render = render

export default script